import React, { Fragment, Component, useEffect, lazy, Suspense } from 'react';
/**Store */
import { Store } from './Store';
/**Theme */
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import theme from './theme';
/**Routes */
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './Routes';
import { withRouter } from 'common/utils/router.util';

/**Styles */
import './assets/scss/index.scss';

/**Notisnackbar installation */
import { SnackbarProvider } from 'notistack';

/**lodash */
import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';
import { isAdminFeatureBlocked, ADMIN_FEATURES } from 'common/roles/adminAccess';

/**
 * Use this file to define all route related stuff and provider related stuff.
 */
/**
 * Update state in context
 */

/**Lazy loading */
const ListGenLoader = (
  <div className="lg-ll-container">
    <div className="lg-ll-grid">
      <img
        alt="ListGen Logo"
        src={(typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '') + '/images/listgen-logo.png'}
        className="lg-ll-grid-image"
      />
    </div>
    <div className="lg-ll-text">Loading Page...</div>
  </div>
);

/**lazy load the session switch and network detector. it only supports the default exports */
const SessionSwitchFABComponent = lazy(() => import('components/SessionSwitchFABV2'));
const NetworkDetectorComponent = lazy(() => import('components/NetworkDetector'));
const SessionRefreshManagerComponent = lazy(() => import('components/SessionRefreshManager'));
const LGPromptXWidgetComponent = lazy(() => import('components/LGPromptXWidget'));

export default function App(props) {

  const { state } = React.useContext(Store);
  
  if (state && state.deepCopy === null) {
    const deepClonedState = _.pick(state, 'values', 'touched', 'errors', 'showPassword', 'submitError',
      'submitSuccess', 'userName', 'userRole');
    state.deepCopy = _.cloneDeep(deepClonedState);
  }

  return (
    <Router>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
        <SnackbarProvider  maxSnack={3}>
          <Suspense fallback={ListGenLoader}>
            <AppRoutes />
          </Suspense>
          <Suspense fallback={ListGenLoader}>
            <NetworkDetectorComponent />
            {/* only blocks starting a switch; an already switched session still gets the FAB to revert */}
            {!isAdminFeatureBlocked(ADMIN_FEATURES.SESSION_SWITCH) && <SessionSwitchFABComponent />}
            <SessionRefreshManagerComponent />
            <LGPromptXWidgetComponent />
          </Suspense>
        </SnackbarProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Router>
  );
  //}
}
